import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import styled from '@emotion/styled';
import { Box, Tab, Tabs } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import React, { useState } from 'react';

export const SpecTab = styled(Tabs)`
	background: #ceedf0;
	border-radius: 30px;
	min-height: 1.5rem;
	min-width: 50px;
	.MuiTab-textColorPrimary {
		z-index: 1;
	}
	.MuiTabs-indicator {
		height: 1.5rem;
		bottom: 5px;
		background-color: #ffffff;
		border-radius: 30px;
	}
`;
export const MeasurementTab = styled(Tab)`
	margin: 5px;
	${getStyle('Small_Medium')}
	color:#777777;
	border-radius: 30px;
	padding: 0rem;
	min-height: 1.5rem;
	min-width: 60px;
	text-transform: lowercase;
	color: #777777 !important;
`;

interface ISpecProps {
	setSpecificationUnit: Function;
	specificationUnit: string;
}

export default function Specstile(props: ISpecProps) {
	return (
		<FlexBox sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
			<SpecTab value={`${props.specificationUnit}`}>
				<MeasurementTab
					label='cm'
					value='cm'
					onClick={() => props.setSpecificationUnit('cm')}
					className={props.specificationUnit === 'cm' ? 'selected' : ''}
				/>
				<MeasurementTab
					label='inch'
					value='inch'
					onClick={() => props.setSpecificationUnit('inch')}
					className={props.specificationUnit === 'inch' ? 'selected' : ''}
				/>
			</SpecTab>
		</FlexBox>
	);
}
